import Api from './Api'
export default {
    getCouncil() {
        return Api().get('/counsil/index');
    },

    getCommittee() {
        return Api().get('/counsil/committee');
    },

    getFilters(id) {
        return Api().get('/counsil/com/' + id);
    }
}